import authConfig from 'src/configs/auth'


const setItem = (key, value, rememberMe = false) => {
  const storage = rememberMe ? localStorage : sessionStorage
  storage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value))
}

const getItem = key => {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(key) || sessionStorage.getItem(key)
}

const removeItem = key => {
  if (typeof window === 'undefined') return null
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)
}

export const clearAll = () => {
  if (typeof window === 'undefined') return null
  localStorage.clear()
  sessionStorage.clear()
}

// 🌐 Public API
export const authStorage = {
  setStoredToken: (key, token, rememberMe) => {
    setItem(key, token, rememberMe)
  },

  getStoredToken: key => {
    return getItem(key)
  },

  clearStoredToken: key => {
    removeItem(key)
  },
  getStoredUser: (key, user, rememberMe) => {
    try {
      return JSON.parse(getItem(key, user, rememberMe)) || null
    } catch {
      return null
    }
  },
  setStoredUser: (key,user, rememberMe ) => {
    setItem(key,user, rememberMe)
  },

  clearUser: () => {
    removeItem('userData')
  },

  isUserLoggedInStatus: () => {
    return Boolean(getItem(authConfig.storageTokenKeyName)) && Boolean(getItem('userData'))
  },

  setStoredClientData: (key, value, rememberMe) => {
    setItem(key, value, rememberMe)
  },
  getStoredClientData: key => {
    return getItem(key)
  },
  clearStoredClientData: () => {
    removeItem('clientData')
  },
  
  setStoredSelectedClientId: (key, value, rememberMe) => {
    setItem(key, value, rememberMe)
  },

  getStoredSelectedClientId: key => {
    return getItem(key)
  },

  clearStoredSelectedClientId: () => {
    removeItem('selectedClientId')
  },
 setUserToken: (token, rememberMe) => {
   setItem('userToken', token, rememberMe)
 },
 getUserToken: () => {
   return getItem('userToken')
 },
 setAIConfiguration:(key ,value,rememberMe)=>{
   setItem(key, value,rememberMe)
 },
 getAIConfiguration:(key)=>{
  getItem(key)
 },
      
 

  // setAuthData: (key, value, rememberMe) => {
  //   return setStoredSelectedClientId && setStoredUser && setStoredToken && setStoredSelectedClientId
  // },
  // clearAuth: () => {
  
  //   authStorage.clearStoredSelectedClientId()
  //   authStorage.clearStoredClientData()
  //   authStorage.clearUser()
  //   authStorage.clearStoredToken()
    
  // }
    clearAuth: () => {
    // Flush out all memory completely
    localStorage.clear()
    sessionStorage.clear()
  }
}